<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16">
    <path
      d="M8.823 9.32H5.977c-.51 0-4.977.068-4.977 2.4v3.36h12.8v-3.36c0-2.332-4.467-2.4-4.977-2.4zm3.966 4.8H2.011v-2.4c0-1.085 2.672-1.439 3.966-1.44h2.846c1.294 0 3.966.352 3.966 1.44v2.4zM7.08 8.04a3.52 3.52 0 1 0 0-7.04 3.52 3.52 0 0 0 0 7.04zm0-6.058A2.54 2.54 0 0 1 9.618 4.52 2.54 2.54 0 0 1 7.08 7.058 2.54 2.54 0 0 1 4.542 4.52 2.54 2.54 0 0 1 7.08 1.982z"
    />
  </svg>
</template>
